import { useCallback, useMemo, useState } from "react";
import { IModules, IStation } from "../../../../models/IUser";
import { getDeviceTypeConfig } from "../deviceTypeConfig";
import { useModuleFieldState } from "./useModuleFieldState";
import { useStationsState } from "./useStationsState";
import { useChildModulesState } from "./useChildModulesState";

export function useModuleForm(
  module: IModules | null,
  stations: IStation[],
  modules: IModules[],
) {
  const [isMutated, setMutated] = useState(false);
  const markMutated = useCallback(() => setMutated(true), []);

  const config = useMemo(
    () => getDeviceTypeConfig(module?.device_type),
    [module?.device_type],
  );

  const moduleField = useModuleFieldState(module, markMutated);
  const stationsState = useStationsState(module, stations, config, markMutated);
  const childModulesState = useChildModulesState(module, modules, markMutated);

  const resetAfterSave = () => {
    moduleField.reset();
    stationsState.reset();
    childModulesState.reset();
    setMutated(false);
  };

  return {
    editedModule: moduleField.editedModule,
    isMutated,
    config,
    changedModuleFields: moduleField.changedModuleFields,
    changedModuleFieldKeys: moduleField.changedModuleFieldKeys,
    fieldErrors: moduleField.fieldErrors,
    validateModuleFields: moduleField.validateAll,
    stationsState: stationsState.stationsState,
    childModulesState: childModulesState.childModulesState,
    handleModuleChange: moduleField.handleChange,
    handleStationChange: stationsState.handleChange,
    handleChildModuleChange: childModulesState.handleChange,
    setModuleField: moduleField.setField,
    addChildSlot: childModulesState.addChildSlot,
    resetAfterSave,
    modifiedStations: stationsState.modifiedStations,
    modifiedChildModules: childModulesState.modifiedChildModules,
  };
}
